const linkLandingPagesEN = {
    "view": {
        "table": {
            "title": "Your link landing pages",
            "column": {
                "title": "Title",
                "description": "Description",
                "backUrl": "Back Url",
                "created": "Created",
                "landingPage": "Landing Page",
                "action": "Action"
            },
            "label": {
                "landingPage": "Landing Page",
            },
            "button": {
                "view": "View",
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "message": {
                "linkCopied": "Link copied to clipboard!"
            }
        },
        "modal": {
            "edit": {
                "header": "Edit {{linkLandingPageName}}?",
                "body": "Are you sure that you want to edit this link landing page?",
            },
            "delete": {
                "header": "Delete {{linkLandingPageName}}?",
                "body": "Are you sure that you want to delete this link landing page?",
            }
        },
        "message": {
            "success": "Link Landing Page has been removed!",
            "error": "Something went wrong! Please refresh page and try again!",
            "llpAllowanceSpent": "You have spent your link landing page allowance. In order to create more link landing pages please upgrade your account or contact our support team.",
            "subscriptionFeatureUnavailable": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        }
    },
    "add": {
        "title": "Add Link Landing Page",
        "form": {
            "label": {
                "domain": "Domain",
                "title": "Title",
                "backUrl": "Back Url",
                "shortDescription": "Short Description",
                "logo": "Logo",
                "backgroundImage": "Background Image",
                "blurredBackground": "Blurred Background",
                "blurred": "Blurred",
                "notBlurred": "Not Blurred",
                "blurStrength": "Blur Strength",
                "layout": "Layout",
                "font": "Font",
                "socialIconPlacement": "Social Icon Placement",
                "socialIconColor": "Social Icon Color",
                "buttonCorners": "Button Corners",
                "buttonStyle": "Button Style",
                "colorCustomisation": "Color Customisation",
                "premadeColors": "Premade Colors",
                "customColors": "Custom Colors",
                "headerBackground": "Header Background",
                "singleColor": "Single Color",
                "gradient": "Gradient",
                "bodyBackground": "Body Background",
                "titleColor": "Title Color",
                "descriptionColor": "Description Color",
                "buttonColor": "Button Color",
                "buttonTextColor": "Button Text Color",
                "backgroundColor": "Background Color"
            },
            "placeholder": {
                "domain": "Select Domain",
                "shortDescription": "A few words about your landing page. 80 characters max"
            },
            "help_text": {
                "domain": "Select the domain for which you want to create Link Landing Page.",
                "logo": "Upload JPG or PNG formats, resolution atleast 500x500 px",
                "backgroundImage": "Upload JPG or PNG formats, resolution of 1000x1000 px",
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout One",
                    "layoutTwo": "Layout Two"
                },
                "socialIconPlacement": {
                    "header": "Header",
                    "bottomOfTheBody": "Bottom Of The Body"
                },
                "socialIconColor": {
                    "color": "Color",
                    "black": "Black",
                    "white": "White"
                },
                "buttonCorners": {
                    "rounded": "Rounded",
                    "semiRounded": "Semi Rounded",
                    "squared": "Squared"
                },
                "buttonStyle": {
                    "outlined": "Outlined",
                    "filled": "Filled"
                },
            },
            "button": {
                "submit": "Submit",
            },
            "validation": {
                "formInvalid": "Form cannot be submited! Please fill all fields and check errors!",
                "storeUrlRequired": "{{store}} Url is required",
                "storeUrlValid": "Please add a valid {{store}} Url."
            }
        },
        "message": {
            "success": "Link Landing Page has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "add": {
                "header": "Add Landing Page {{title}}?",
                "body": "Are you sure you want to create Link Landing Page with the title {{title}}?"
            }
        }
    },
    "update": {
        "title": "Update Link Landing Page",
        "form": {
            "label": {
                "domain": "Domain",
                "title": "Title",
                "backUrl": "Back Url",
                "shortDescription": "Short Description",
                "logo": "Logo",
                "backgroundImage": "Background Image",
                "blurredBackground": "Blurred Background",
                "blurred": "Blurred",
                "notBlurred": "Not Blurred",
                "blurStrength": "Blur Strength",
                "layout": "Layout",
                "font": "Font",
                "socialIconPlacement": "Social Icon Placement",
                "socialIconColor": "Social Icon Color",
                "buttonCorners": "Button Corners",
                "buttonStyle": "Button Style",
                "colorCustomisation": "Color Customisation",
                "premadeColors": "Premade Colors",
                "customColors": "Custom Colors",
                "headerBackground": "Header Background",
                "singleColor": "Single Color",
                "gradient": "Gradient",
                "bodyBackground": "Body Background",
                "titleColor": "Title Color",
                "descriptionColor": "Description Color",
                "buttonColor": "Button Color",
                "buttonTextColor": "Button Text Color",
                "backgroundColor": "Background Color"
            },
            "placeholder": {
                "domain": "Select Domain",
                "shortDescription": "A few words about your landing page. 80 characters max"
            },
            "help_text": {
                "domain": "Select the domain for which you want to create Link Landing Page.",
                "logo": "Upload JPG or PNG formats, resolution atleast 500x500 px",
                "backgroundImage": "Upload JPG or PNG formats, resolution of 1000x1000 px",
            },
            "options": {
                "layout": {
                    "layoutOne": "Layout One",
                    "layoutTwo": "Layout Two"
                },
                "socialIconPlacement": {
                    "header": "Header",
                    "bottomOfTheBody": "Bottom Of The Body"
                },
                "socialIconColor": {
                    "color": "Color",
                    "black": "Black",
                    "white": "White"
                },
                "buttonCorners": {
                    "rounded": "Rounded",
                    "semiRounded": "Semi Rounded",
                    "squared": "Squared"
                },
                "buttonStyle": {
                    "outlined": "Outlined",
                    "filled": "Filled"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Other"
                }
            },
            "button": {
                "submit": "Submit",
            },
        },
        "message": {
            "success": "Link Landing Page has been updated!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "update": {
                "header": "Update Landing Page {{title}}?",
                "body": "Are you sure you want to update Link Landing Page with the title {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Social Links",
        "label": {
            "order": "Order",
            "platform": "Platform",
            "destinationUrl": "Destination Url"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Other"
            }
        },
        "button": {
           "remove": "Remove",
           "add": "Add Another"
        },
    },
    "featuredLinksRow": {
        "title": "Featured Links",
        "label": {
            "order": "Order",
            "label": "Label",
            "destinationUrl": "Destination Url"
        },
        "button": {
           "remove": "Remove",
           "add": "Add Another"
        },
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Fetching Analytics for Music Link",

        },
        "button": {
            "last7Days": "Last 7 Days",
            "last14Days": "Last 14 Days",
            "last30Days": "Last 30 Days"
        },
        "linkLandingPageViews": {
            "title": "Link Landing Page Views",
            "subtitle": "Total Views",
            "label": {
                "views": "Views"
            }
        },
        "socialLinkClicks": {
            "title": "Social Link Clicks",
            "subtitle": "Total Clicks",
            "table": {
                "column": {
                    "platform": "Platform",
                    "destinationUrl": "Destination Url",
                    "clicks": "Clicks",
                    "clicksPct": "Clicks (%)"
                },
            }
        },
        "featuredLinkClicks": {
            "title": "Featured Link Clicks",
            "subtitle": "Total Clicks",
            "table": {
                "column": {
                    "label": "Label",
                    "destinationUrl": "Destination Url",
                    "clicks": "Clicks",
                    "clicksPct": "Clicks (%)"
                },
            }
        },
        "topTerritories": {
            "title": "Top Territories",
            "subtitle": "Total Views",
            "table": {
                "column": {
                    "territory": "Territory",
                    "views": "Views",
                    "viewsPct": "Views (%)"
                },
                "label": {
                    "otherTerritories": "Other Territories"
                }
            }
        },
        "topBrowsers": {
            "title": "Top Browsers",
            "subtitle": "Total Views",
            "table": {
                "column": {
                    "browser": "Browser",
                    "views": "Views",
                    "viewsPct": "Views (%)"
                },
            }
        },
        "topDeviceTypes": {
            "title": "Top Device Types",
            "table": {
                "column": {
                },
            }
        },
        "topOperatingSystems": {
            "title": "Top Operating Systems",
            "label": {
                "os": "Operating System",
                "views": "Views"
            }
        }
    }
};

export default linkLandingPagesEN;